import { render, staticRenderFns } from "./firmSign.vue?vue&type=template&id=f5b5dfca&scoped=true"
import script from "./firmSign.vue?vue&type=script&lang=js"
export * from "./firmSign.vue?vue&type=script&lang=js"
import style0 from "./firmSign.vue?vue&type=style&index=0&id=f5b5dfca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b5dfca",
  null
  
)

export default component.exports